export function getDataFromProperties(editableRule, specificRule, paramLabel, defaultValue){
   
    return editableRule && editableRule[paramLabel] ? editableRule[paramLabel] : specificRule && specificRule[paramLabel] ? specificRule[paramLabel]: defaultValue
}